const containsCssClass = (cssClass: string, nodeCssClasses: string) =>
  ` ${nodeCssClasses} `.indexOf(` ${cssClass} `) > -1

const cssClassIn = (
  cssClassesArr: Record<string, string> | string[],
  nodeCssClasses: string
) =>
  Object.values(cssClassesArr).reduce(
    (result, cssClass) => result || containsCssClass(cssClass, nodeCssClasses),
    false
  )

const fbCssClasses = {
  post: 'fb-post',
  video: 'fb-video',
}

const instagramCssClasses = {
  post: 'scrbbl-post-embed',
}

const instagramUrl = (url: string) =>
  url.split('/').some((chunk) => chunk === 'www.instagram.com')

const twitterUrl = (twitterBlockquote: any) => {
  if (!twitterBlockquote.children) {
    return null
  }

  let url = null
  for (const childNode of twitterBlockquote.children) {
    if (childNode.name === 'a' && childNode.attribs) {
      url = childNode.attribs.href
    }
  }
  return url
}

export {
  cssClassIn,
  fbCssClasses,
  twitterUrl,
  instagramCssClasses,
  instagramUrl,
}
